<template>
  <div class="com-container">
    <div class="com-chart" ref="trend_ref"></div>
  </div>
</template>

<script>
import axios from "axios";
export default {
  data() {
    return {
      chartInstane: null,
      allData: null, // 从服务器中获取的所有数据
      titleFontSize: 0, // 指明标题的字体大小
    };
  },
  mounted() {
    this.initChart();
    this.getData();
    window.addEventListener("resize", this.screenAdapter);
    this.screenAdapter();
  },
  destroyed() {
    window.removeEventListener("resize", this.screenAdapter);
  },
  methods: {
    initChart() {
      this.chartInstane = this.$echarts.init(this.$refs.trend_ref, "chalk");
      const initOption = {
        title: {
          text: "日平均产能",
          right: "8%",
          top: 0,
          textStyle: {
            fontSize: 14,
          },
        },
        grid: {
          left: "8%",
          top: "15%",
          right: "8%",
          bottom: "5%",
          containLabel: true,
        },
        tooltip: {
          trigger: "axis",
        },
        legend: {
          left: "center",
          top: "10",
          icon: "circle",
          show: true,
        },
        xAxis: {
          type: "category",
          boundaryGap: false,
          axisLabel: {
            color: "#fff",
          },
        },
        yAxis: {
            name: "单位/h",
          nameTextStyle: {
            color: "#fff",
          },
          type: "value",
          axisLabel: {
            color: "#fff",
          },
          max: 24,
          interval: 6,
        },
      };
      this.chartInstane.setOption(initOption);
    },
    async getData() {
      const res = await axios.get(this.$api.equipmentTypeCapacityAnalysis);
      this.allData = res.data.data;
      this.updateChart();
    },
    updateChart() {
      // 处理数据
      // 类目轴的数据
      const timeArr = this.allData.axisData;
      // y轴的数据 series下的数据
      const seriesArr = this.allData.items.map((v, i) => {
        return {
          name: v.name,
          type: "line",
          data: v.data,
        };
      });
      // 图例的数据
      const dataOption = {
        xAxis: {
          data: timeArr,
        },
        series: seriesArr,
      };
      this.chartInstane.setOption(dataOption);
    },
    screenAdapter() {
      this.titleFontSize = (this.$refs.trend_ref.offsetWidth / 100) * 3.6;
      const adapterOption = {
        legend: {
          itemWidth: this.titleFontSize / 1.5,
          itemHeight: this.titleFontSize / 1.5,
          itemGap: this.titleFontSize,
          textStyle: {
            fontSize: this.titleFontSize / 1.5,
            color: "#fff",
          },
        },
      };
      this.chartInstane.setOption(adapterOption);
      this.chartInstane.resize();
    },
  },
};
</script>

<style lang="less" scoped>
.title {
  position: absolute;
  left: 20px;
  top: 20px;
  z-index: 10;
  color: white;
}
</style>
